<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item active>{{$t('wallet.label')}}</b-breadcrumb-item>
        </b-breadcrumb>
        <b-tabs class="sm" >
            <b-tab :title="$t('title.14')" :active="!tabPending" @click="changeTab(false)">
                <div v-if="!isDetail">
                <!-- <div v-if="false"> -->
                    <b-row>
                        <b-col cols="4">
                            <div class="paymentDate" >
                                <img src="@/assets/img/cell-phone-hand.png" class="mb-2">
                                <h6 class="bold mb-1" style="font-size:15px;" >{{$t('wallet.lastPayment')}}</h6>
                                <div class="d-flex align-items-center">
                                    <img src="@/assets/icons/icon-calendar.svg" class="svg">
                                    <span style="font-size:15px;">{{lastDatePayment == '' ? '-' : lastDatePayment}}</span>
                                </div>
                            </div>
                        </b-col>
                        <b-col>
                            <b-table hover :items="itemsPayments" :fields="fieldsPayments" :busy="isBusy" :show-empty="true"
                                :tbody-transition-props="transProps" :empty-text="$t('reusables.empty-text')">
                                <template #table-busy>
                                    <div class="text-center text-danger my-2">
                                        <b-spinner class="align-middle"></b-spinner>
                                        <strong> {{$t('ClassRequest.Loading')}}...</strong>
                                    </div>
                                </template>
                                <template #cell(id)="data">
                                    <a @click="toggleDetail(true, data.value)" class="link">{{$t('wallet.details')}}</a>
                                </template>
                            </b-table>
                            <div class="overflow-auto content-pagination">
                                <b-pagination
                                    v-model="currentPagePayment"
                                    :total-rows="totalRowsPayment"
                                    :per-page="perPage"
                                    @change="getPayments()"
                                    aria-controls="my-table">
                                </b-pagination>
                                {{currentPagePayment}}-{{perPage}} / {{totalRowsPayment}}  {{$t('ClassRequest.text.3')}}
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div v-else>
                    <div style="margin-bottom: 24px;"> 
                        <div @click="toggleDetail(false)" class="back-step mt-0" style="margin-bottom:30px">
                            <icon name="arrow-left" />{{$t('wallet.return')}}
                        </div>
                        <b-row>
                            <b-col>
                                <p style="font-size:15px;"><span class="bold">{{$t('wallet.range')}}</span> {{dateRangeDetail}}</p>
                            </b-col>
                            <b-col class="d-flex justify-content-end">
                                <p class="blue" style="font-size:15px,"><span class="bold">{{$t('wallet.paymentReceived')}}</span>$ {{totalAmount}}</p>
                            </b-col>
                        </b-row>
                        <b-form-group>
                            <v-autocomplete style="width:320px;" class="m-auto" :items="students" v-model="student" :min-len="0" :get-label="getLabelDetail" :component-item='template' @update-items="updateItems" :auto-select-one-item="false" :placeholder="$t('wallet.placeholderStudentGruoup')">
                            </v-autocomplete>
                        </b-form-group>
                    </div>
                    <b-table hover :items="itemsDetails" :fields="fieldsDetail" :busy="isBusy" :show-empty="true"
                        :tbody-transition-props="transProps" :empty-text="$t('reusables.empty-text')">
                        <template #table-busy>
                            <div class="text-center text-danger my-2">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong> {{$t('ClassRequest.Loading')}}...</strong>
                            </div>
                        </template>
                    </b-table>
                    <div class="overflow-auto content-pagination">
                        <b-pagination
                            v-model="currentPageDetail"
                            :total-rows="totalRowsDetail"
                            :per-page="perPage"
                            @change="getPaymentDetail()"
                            aria-controls="my-table">
                        </b-pagination>
                        {{currentPageDetail}}-{{perPage}} / {{totalRowsDetail}}  {{$t('ClassRequest.text.3')}}
                    </div>
                </div>
            </b-tab>
            <b-tab :title="$t('title.15')"  :active="tabPending" @click="changeTab(true)">
                <div style="margin-bottom: 24px;">
                    <b-row>
                        <b-col>
                            <p style="font-size:15px;"><span class="bold"  >{{$t('wallet.range')}}</span> {{dateRangePending}}</p>
                        </b-col>
                        <b-col class="d-flex justify-content-end">
                            <p class="blue" style="font-size:15px,"><span class="bold">{{$t('wallet.paymentReceived')}}</span>$ {{totalAmount}}</p>
                        </b-col>
                    </b-row>
                    <b-form-group>
                        <v-autocomplete placeholder="Student / Group" style="width:320px;" class="m-auto" :items="students" v-model="student" :min-len="0" :get-label="getLabelPending" :component-item='template' @update-items="updateItems" :auto-select-one-item="false"></v-autocomplete>
                    </b-form-group>
                </div>
                <b-table hover :items="itemsPending" :fields="fieldsDetail" :busy="isBusy" :show-empty="true"
                    :tbody-transition-props="transProps" :empty-text="$t('reusables.empty-text')">
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> {{$t('ClassRequest.Loading')}}...</strong>
                        </div>
                    </template>
                </b-table>
                <div class="overflow-auto content-pagination">
                    <b-pagination
                        v-model="currentPagePending"
                        :total-rows="totalRowsPending"
                        :per-page="perPage"
                        @change="getPendingPayments()"
                        aria-controls="my-table">
                    </b-pagination>
                    {{currentPagePending}}-{{perPage}} / {{totalRowsPending}}  {{$t('ClassRequest.text.3')}}
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';
import ItemTemplate from "@/views/teacher/class/ItemTemplate "; //Reusable, mover
import * as tools from '@/assets/js/tools.js';
import { getNextClassDate,getNextClassTime } from '@/assets/js/util.js';

export default {
    data() {
        return {
            tabPending: false,
            isDetail: false,
            isBusy: false,
            lastDatePayment: '',
            currentPagePayment: 1,
            perPage: 10,
            totalRowsPayment: 0,
            currentPageDetail: 1,
            totalRowsDetail: 0,
            currentPagePending: 1,
            totalRowsPending: 0,
            detailValue: 0,
            groupValue: 0,
            students: [],
            student: null,
            dateRangeDetail: "",
            dateRangePending: "",
            totalAmount: '0.00',
            transProps: {
                name: 'flip-list'
            },
            fieldsPayments: [
                {key:'dateCreated', label:this.$t('wallet.table-th.date'), formatter: (v, k, i) => {return this.$moment(v).format("MM/DD/YYYY")}},
                {key:'totalHoursClass', label:this.$t('wallet.table-th.totalHoursClass')},
                {key:'amount', label:this.$t('wallet.table-th.amount')},
                {key:'customDateLastClass', label:this.$t('wallet.table-th.customDateLastClass')},
                {key:'id', label:''}
            ],
            fieldsDetail: [
                {key:'nameClass', label:this.$t('wallet.table-th.nameClass')},
                {key:'flagPlanTest', label:this.$t('wallet.table-th.typeClass'), formatter: (v, k, i) => {return v ? "Trial class" :  "Recurring Schedule"}},
                {key:'startDate', label:this.$t('wallet.table-th.date'), formatter: (v, k, i) => {return this.$moment(v).format("MM/DD/YYYY")}},
                {key:'priceByHour', label:this.$t('wallet.table-th.priceByHour'), formatter: (v, k, i) => {return "$ " + v}},
                {key:'strClassDuration', label:this.$t('wallet.table-th.strClassDuration')},
                {key:'strAmount', label:this.$t('wallet.table-th.strAmount'), formatter: (v, k, i) => {return `$ ${v}`}}
            ],
            itemsPayments: [],
            itemsDetails: [],
            itemsPending: [],
            template: ItemTemplate
        }
    },
    computed: {
        user: {
            get() {
                return this.$store.state.user;
            }
        }
    },
    mounted(){
        this.getPayments();
    },
    methods: {
        changeTab(state){
            this.tabPending = state;
            if(state){
                this.student = null;
                this.students = [];
                this.itemsPending = [];
                this.currentPagePending = 1;
                this.totalRowsPending = 0;
                this.getPendingPayments();
            }
            else{
                this.currentPagePayment = 1;
                this.totalRowsPayment = 0;
                this.itemsPayments = [];
                this.isDetail = false;
                this.getPayments();
            }
            this.totalAmount = "0.00";
        },
        toggleDetail(state, id){
            this.isDetail = state;

            if(state){
                this.detailValue = id;
                this.student = null;
                this.currentPageDetail = 1;
                this.totalRowsDetail = 0;
                this.itemsDetails = [];
                this.students = [];
                this.getPaymentDetail();
                
            }
            else{
                this.currentPagePayment = 1;
                this.totalRowsPayment = 0;
                this.itemsPayments = [];
                this.getPayments();
                this.detailValue = 0;
            }
            this.totalAmount = "0.00";
        },
        getLabelDetail(student) {
            this.student = student;
            this.getPaymentDetail();
            return student?.name;
        },
        getLabelPending(student) {
            this.student = student;
            this.getPendingPayments();
            return student?.name;
        },
        updateItems(text) {
            let params = {
                Id: this.user.personTeacherId,
                Filter: text
            }
            
            baseInstanceAxios
                .get(`${this.apiURL}/resources/PersonsTeachers/ComboStudentByAutocomplete`, {params})
                .then((response) => {
                    if(response.data && response.data.list){
                        this.students = response.data.list.map(x => ({id: x.id, name: x.descripcion}));
                    }
                });
                this.$nextTick(function () {
                    tools.imgToSvg()
                })
        },
        getPayments(){
            this.isBusy = true;

            let params = {
                idTeacher: this.user.personTeacherId,
                page: this.currentPagePayment,
                size: this.perPage
            };
            let format_day = "MM/DD/YYYY";
            let format_time = "h:mm a";
            baseInstanceAxios
                .get(`${this.apiURL}/Resources/PersonsTeachers/GetPayments`, {params})
                .then(response => {
                    if(response.data != null && response.data.list != null){
                        this.lastDatePayment = response.data.entity ? response.data.entity.dateLastClass  : '';
                        this.itemsPayments = response.data.list.map(x => ( {
                                         id : x.id,
                                         totalHoursClass : x.totalHoursClass,
                                         amount : x.amount,
                                         dateLastClass : getNextClassDate(x.dateTimeLastClass, this.$store.state.user.timeZoneName, this.$moment, format_day),
                                         customDateLastClass : getNextClassDate(x.customDateTimeLastClass, this.$store.state.user.timeZoneName, this.$moment, format_day),
                                         dateCreated : x.dateCreated,
                                         personTeacher : {
                                             person :
                                             {
                                                 firstName : x.personTeacher.person.firstName,
                                                 lastName : x.personTeacher.person.lastName,
                                                 email : x.personTeacher.person.email,
                                                 phoneNumber : x.personTeacher.person.phoneNumber,
                                                 extension_Phone : x.personTeacher.person.Extension_Phone
                                             }
                                         }
                                     }));
                        this.totalRowsPayment = response.data.rows;
                    }
                });
                this.$nextTick(function () {
                    tools.imgToSvg()
                })

            this.isBusy = false;
        },
        getPaymentDetail(){
            if(this.detailValue){

                this.isBusy = true;

                let params = {
                    idPayment: this.detailValue,
                    idGroup: this.student ? this.student.id : null,
                    page: this.currentPageDetail,
                    size: this.perPage
                };
                 let format_day = "MM/DD/YYYY";
                 let format_time = "h:mm a";
                baseInstanceAxios
                    .get(`${this.apiURL}/Resources/PersonsTeachers/ListPaymentDetail`, {params})
                    .then(response => {
                        if(response.data != null && response.data.list != null){
                            let date = response.data.entity;
                            if(date){
                          //this.dateRangeDetail = date.strStartEndDate;
                            this.dateRangeDetail = getNextClassDate(date.startDate, this.$store.state.user.timeZoneName, this.$moment, format_day) +" - "+
                            getNextClassDate(date.endDate, this.$store.state.user.timeZoneName, this.$moment, format_day);
                            }
                            this.totalAmount = response.data.message;
                            this.itemsDetails = response.data.list;
                            this.totalRowsDetail = response.data.rows;
                        }
                    });
                    this.$nextTick(function () {
                        tools.imgToSvg()
                    })

                this.isBusy = false;
            }
        },
        getPendingPayments(){
            this.isBusy = true;

            let params = {
                idTeacher: this.user.personTeacherId,
                idGroup: this.student ? this.student.id : null,
                page: this.currentPagePending,
                size: this.perPage
            };

            let format_day = "MM/DD/YYYY";
            let format_time = "h:mm a";
            baseInstanceAxios
                .get(`${this.apiURL}/Resources/PersonsTeachers/ListPendingPayments`, {params})
                .then(response => {
                    if(response.data != null && response.data.list != null){
                        let date = response.data.entity;
                        this.dateRangePending = "";
                        if(date){
                             //this.dateRangePending = date.strStartEndDate;
                            this.dateRangePending = getNextClassDate(date.startDate, this.$store.state.user.timeZoneName, this.$moment, format_day) 
                                                    + " - " +
                                                    getNextClassDate(date.endDate, this.$store.state.user.timeZoneName, this.$moment, format_day);
                                                     
                        }
                        this.totalAmount = response.data.message;
                        if(response.data.list != null){
                         this.itemsPending = response.data.list.map(x => ({
                            nameClass: x.nameClass,
                            flagPlanTest: x.flagPlanTest,
                            startDate : getNextClassDate(x.startDate, this.$store.state.user.timeZoneName, this.$moment, format_day),
                            priceByHour: x.priceByHour,
                            strClassDuration:x.strClassDuration,
                            strAmount: x.strAmount,
                            classDuration: x.classDuration,
                        }));
                        }
                        

                        this.totalRowsPending = response.data.rows;
                    }
                });
                this.$nextTick(function () {
                    tools.imgToSvg()
                })

            this.isBusy = false;
        }
    }
}
</script>